/**
 * Overtime Report Service
 * 
 * API calls for overtime (HHEE) reports
 */

import { apiClient } from '@/api/core/apiClient';
import { API_CONFIG } from '@/api/core/apiConfig';
import type { ApiResponse } from '@/api/shared/types';
import type {
  LC_GetOvertimeReportIn,
  LC_OvertimeReportDataOut,
  OvertimeReportResult,
} from './overtimeReport.types';
import { mapOvertimeReportResponse } from './overtimeReport.mapper';


export class OvertimeReportService {
  /**
   * Get overtime report for a specific month/cut
   */
  async getReport(input: LC_GetOvertimeReportIn): Promise<ApiResponse<OvertimeReportResult>> {
    const queryParams = new URLSearchParams({
      year: input.year.toString(),
      month: input.month.toString(),
      monthlyCutId: input.monthlyCutId.toString(),
      type: input.type,
      page: input.page.toString(),
      pageSize: input.pageSize.toString(),
      orderDirection: input.orderDirection,
    });

    // Add orderBy if provided
    if (input.orderBy) {
      queryParams.append('orderBy', input.orderBy);
    }

    const endpoint = `${API_CONFIG.ENDPOINTS.MONTHLY_REPORT}/hhee?${queryParams
      .toString()}`;

    // The backend envelope wraps the data, apiClient unwraps it to return
    // LC_OvertimeReportDataOut directly
    const response = await apiClient.get<LC_OvertimeReportDataOut>(endpoint);

    if (!response.success || !response.data) {
      return {
        success: false,
        data: null,
        error: response.error,
        status: response.status,
      };
    }

    return {
      success: true,
      data: mapOvertimeReportResponse(response.data),
      status: response.status,
    };
  }
}

export const overtimeReportService = new OvertimeReportService();
